import { put, select, takeEvery } from "redux-saga/effects"
import {
  axiosPut,
  delPollsAxios,
  getPollsAxios,
  postPollsAxios,
  getPollsAxiosWithParams,
  putPollsAxios,
  get,
  post,
} from "helpers/api_helper"
import { getFormDataFromJSON, showToast } from "utils"
import {
  showSavingModal,
  hideSavingModal,
  putMenuItemSuccess,
  setSelectedFeature,
  setIsOutdated,
} from "../actions"
import {
  addSurveyFailed,
  addSurveySuccess,
  deleteSurveyFailed,
  deleteSurveySuccess,
  getSurveyFeatureFailed,
  getSurveyFeatureRecipientsFailed,
  getSurveyFeatureRecipientsSuccess,
  getSurveyFeatureSuccess,
  getSurveyListFailed,
  getSurveyListSuccess,
  getSurveyReplyFailed,
  getSurveyReplySuccess,
  hideDeleteSurveyModal,
  updateSurveyFailed,
  updateSurveyOrderFailed,
  updateSurveyOrderSuccess,
  updateSurveyResponseFailed,
  updateSurveyResponseSuccess,
  updateSurveyStatusFailed,
  updateSurveyStatusSuccess,
  updateSurveySuccess,
} from "./actions"
import {
  ADD_SURVEY,
  DELETE_SURVEY,
  GET_SURVEY_FEATURE,
  GET_SURVEY_FEATURE_RECIPIENTS,
  GET_SURVEY_LIST,
  GET_SURVEY_REPLY,
  UPDATE_SURVEY,
  UPDATE_SURVEY_ORDER,
  UPDATE_SURVEY_RESPONSE,
  UPDATE_SURVEY_STATUS,
} from "./actionTypes"
import * as url from "helpers/url_helper"

function* addSurvey({ payload: params }) {
  try {
    yield put(showSavingModal())
    const questionResponse = yield postPollsAxios("/question", {
      questions: params.questions,
    })
    const surveyResponse = yield postPollsAxios(
      "/survey",
      getFormDataFromJSON({
        ...params.survey,
        questions: questionResponse.map(question => question.id),
      })
    )
    if (params.survey.menu_feature === 1) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: surveyResponse.id,
        menu_item_id: surveyResponse.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setSelectedFeature(menuItem))
    } else {
      const responseList = yield getPollsAxiosWithParams("/survey", {
        params: {
          event_id: params.survey.event_id,
          menu_item_id: params.survey.menu_item_id,
        },
      })
      yield put(getSurveyListSuccess(responseList))
    }
    yield put(addSurveySuccess(surveyResponse))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addSurveyFailed(error))
  }
}

function* getSurveyFeature({ payload: params }) {
  try {
    const response = yield getPollsAxios(`/survey/${params}`)
    const destroyed = yield select(state => state.Survey.destroyed)
    if (!destroyed) {
      yield put(getSurveyFeatureSuccess(response))
    }
  } catch (error) {
    yield put(getSurveyFeatureFailed(error))
  }
}

function* updateSurvey({ payload: params }) {
  try {
    yield put(showSavingModal())
    const questionIds = []
    for (let question of params.updatedQuestions) {
      const response = yield putPollsAxios(`/question/${question.id}`, question)
      questionIds.push(response.id)
    }
    if (params.newQuestions.length > 0) {
      const newQuestionsResponse = yield postPollsAxios("/question", {
        questions: params.newQuestions,
      })
      newQuestionsResponse.forEach(item => {
        questionIds.push(item.id)
      })
    }
    const surveyResponse = yield postPollsAxios(
      `/survey/${params.survey.id}`,
      getFormDataFromJSON({
        ...params.survey,
        questions: questionIds,
      }),
      {
        params: { menu_item_id: params.survey.menu_item_id },
      }
    )
    if (params.survey.menu_feature) {
      const updatedSurvey = yield getPollsAxios(`/survey/${params.survey.id}`)
      yield put(getSurveyFeatureSuccess(updatedSurvey))
    }
    yield put(updateSurveySuccess(surveyResponse))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateSurveyFailed(error))
  }
}

function* updateSurveyResponse({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield postPollsAxios(
      `/survey/${params?.responsesValues?.survey_id}/responses-setup`,
      params?.responsesValues
    )
    yield post(url.FEATURE_RECIPIENTS_URL, params?.featureRecipientsValues)
    yield put(updateSurveyResponseSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateSurveyResponseFailed(error))
  }
}

function* getSurveyList({ payload: params }) {
  try {
    const response = yield getPollsAxiosWithParams("/survey", { params })
    const destroyed = yield select(state => state.Survey.listDestroyed)
    if (!destroyed) {
      yield put(getSurveyListSuccess(response))
    }
  } catch (error) {
    yield put(getSurveyListFailed(error))
  }
}

function* deleteSurvey({ payload: params }) {
  try {
    const response = yield delPollsAxios(`/survey/${params.id}`, {
      menu_item_id: params.menu_item_id,
    })
    yield put(deleteSurveySuccess(response))
    yield put(hideDeleteSurveyModal())
  } catch (error) {
    yield put(deleteSurveyFailed(error))
  }
}

function* updateSurveyOrder({ payload: params }) {
  try {
    const response = yield postPollsAxios(
      `/survey/${params.id}`,
      getFormDataFromJSON(params),
      {
        params: { menu_item_id: params.menu_item_id },
      }
    )
    yield put(updateSurveyOrderSuccess(response))
  } catch (error) {
    yield put(updateSurveyOrderFailed(error))
  }
}

function* updateSurveyStatus({ payload: params }) {
  try {
    const response = yield postPollsAxios(
      `/survey/${params.id}`,
      getFormDataFromJSON(params),
      {
        params: { menu_item_id: params.menu_item_id },
      }
    )
    yield put(setIsOutdated(true))
    yield put(updateSurveyStatusSuccess(response))
  } catch (error) {
    yield put(updateSurveyStatusFailed(error))
  }
}

function* getSurveyReply({ payload: params }) {
  try {
    const response = yield getPollsAxios(`/survey/${params?.id}/reply`)

    yield put(getSurveyReplySuccess(response))
  } catch (error) {
    yield put(getSurveyReplyFailed(error))
  }
}

function* getSurveyFeatureRecipients({ payload: params }) {
  try {
    const response = yield get(url.FEATURE_RECIPIENTS_URL, { params })
    yield put(getSurveyFeatureRecipientsSuccess(response))
  } catch (error) {
    yield put(getSurveyFeatureRecipientsFailed(error))
  }
}

function* surveySaga() {
  yield takeEvery(ADD_SURVEY, addSurvey)
  yield takeEvery(GET_SURVEY_FEATURE, getSurveyFeature)
  yield takeEvery(UPDATE_SURVEY, updateSurvey)
  yield takeEvery(GET_SURVEY_LIST, getSurveyList)
  yield takeEvery(UPDATE_SURVEY_RESPONSE, updateSurveyResponse)
  yield takeEvery(DELETE_SURVEY, deleteSurvey)
  yield takeEvery(UPDATE_SURVEY_ORDER, updateSurveyOrder)
  yield takeEvery(UPDATE_SURVEY_STATUS, updateSurveyStatus)
  yield takeEvery(GET_SURVEY_REPLY, getSurveyReply)
  yield takeEvery(GET_SURVEY_FEATURE_RECIPIENTS, getSurveyFeatureRecipients)
}

export default surveySaga
